// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__FormStepLayout__styles-module__layout____snFiiCse9cQtOB5 {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pg7yhRjb__FormStepLayout__styles-module__header___riUPmREFGtYRerdv {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.pg7yhRjb__FormStepLayout__styles-module__footer___VUbJH6o7CyoH8mrs {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/modules/registrationForm/components/FormStepLayout/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".layout {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.footer {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `pg7yhRjb__FormStepLayout__styles-module__layout____snFiiCse9cQtOB5`;
export var header = `pg7yhRjb__FormStepLayout__styles-module__header___riUPmREFGtYRerdv`;
export var footer = `pg7yhRjb__FormStepLayout__styles-module__footer___VUbJH6o7CyoH8mrs`;
export default ___CSS_LOADER_EXPORT___;
